import { combineReducers } from "redux"
import appReducer from "reducers/appReducer"
import authReducer from "modules/auth/reducers"

export default combineReducers({
    app: appReducer,
    auth: authReducer,
})